import { getAttributionForAuth } from "./attributionUtm";
import { isAnyMiniApp } from "./miniApp";
import { readVirtuozYclid } from "./siteAnalyticsStorage";
/** Ключ источника в `click_sources.yaml`. */
export const BOT_CLICK_SOURCE = "site";
const CLICK_PATH = "/api/v1/public/click";
/**
 * База API — та же конвенция, что у axios (`shared/api/base.ts`): origin без
 * `/api`, пусто = относительный путь на свой же домен.
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || "";
/** Гранулярные UTM клика — обогащают строку клика, на `user.utm` не влияют. */
const GRANULAR_UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
];
/**
 * Идти ли в бота через `/click`.
 *
 * - Нет yclid — идём напрямую. У подавляющего большинства его нет, и гонять их
 *   через бэкенд ради пустой строки клика незачем (лишний хоп = лишний риск).
 * - Мини-апп — идём напрямую. Внутри вебвью Telegram/MAX человек УЖЕ пришёл из
 *   бота: рекламной куки сайта у него, как правило, нет, а лишний редирект на
 *   свой домен из вебвью — верный способ сломать открытие ссылки. Не делаем
 *   хуже: поведение остаётся ровно таким, как было.
 */
export function shouldRouteThroughClick(options) {
    if (options.isMiniApp) {
        return false;
    }
    return Boolean(options.yclid && options.yclid.trim());
}
/**
 * URL `/click` для перехода в бота, либо `null`, если клик не нужен
 * (нет yclid). Чистая функция — вся среда приходит аргументами.
 */
export function buildBotClickUrl(params) {
    const yclid = params.yclid?.trim();
    if (!yclid) {
        return null;
    }
    const base = (params.apiBaseUrl ?? API_BASE_URL).replace(/\/+$/, "");
    const query = new URLSearchParams();
    query.set("source", BOT_CLICK_SOURCE);
    query.set("target", params.target);
    const utm = params.utm?.trim();
    if (utm) {
        query.set("utm", utm);
    }
    const granular = params.granularUtm ?? {};
    for (const key of GRANULAR_UTM_KEYS) {
        const value = granular[key]?.trim();
        if (value) {
            query.set(key, value);
        }
    }
    query.set("yclid", yclid);
    return `${base}${CLICK_PATH}?${query.toString()}`;
}
/**
 * Итоговый href кнопки «открыть бота»: либо `/click` (302 унесёт в бота с
 * `click_<id>`), либо прежняя прямая ссылка. Чистая функция.
 */
export function resolveBotLinkUrl(params) {
    if (!shouldRouteThroughClick(params)) {
        return params.botUrl;
    }
    return buildBotClickUrl(params) ?? params.botUrl;
}
/** Гранулярные utm_* из сохранённой атрибуции сайта (first-touch). */
function readGranularUtm() {
    const stored = getAttributionForAuth();
    const out = {};
    for (const key of GRANULAR_UTM_KEYS) {
        const value = stored[key];
        if (value) {
            out[key] = value;
        }
    }
    return out;
}
/**
 * Runtime-обёртка для рендера: сама читает yclid, гранулярные utm_* и контекст
 * мини-аппа. Вызывать прямо в JSX — все чтения синхронные и дешёвые.
 *
 * `utm` — метка, которая раньше ехала в `?start=` этой ссылки (или `undefined`,
 * если ссылка была голой: тогда `user.utm` останется пустым, как и раньше).
 */
export function getBotLinkHref(botUrl, target, utm) {
    return resolveBotLinkUrl({
        botUrl,
        target,
        utm,
        yclid: readVirtuozYclid(),
        granularUtm: readGranularUtm(),
        isMiniApp: isAnyMiniApp(),
    });
}
